import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function SearchItem({index, title, subject, grade, publishingHouse, id, ...props }) {
    const {t} = useTranslation();

    return (
        <li className="flex flex-row py-2 gap-2">
            <div className="mr-11">{index}.</div>
            <div className="flex flex-col">
                <Link  to={`/library/${id}`} className="font-bold hover:cursor-pointer hover:underline">
                    {title}
                </Link>
                <span className="text-[#00000066] text-sm">
                    {t(`libraryPage.filters.grade.${grade}`)}. {t(`libraryPage.filters.subject.${subject}`)}
                </span>
            </div>
        </li>
    );
}

export default SearchItem;
